'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (GamingTransactionColumn) {
    GamingTransactionColumn["ID"] = "id";
    GamingTransactionColumn["GAME"] = "game";
    GamingTransactionColumn["DATE"] = "date";
    GamingTransactionColumn["TIME"] = "time";
    GamingTransactionColumn["BET"] = "bet";
    GamingTransactionColumn["WIN"] = "win";
})(exports.GamingTransactionColumn || (exports.GamingTransactionColumn = {}));
(function (PaymentTransactionColumn) {
    PaymentTransactionColumn["ID"] = "id";
    PaymentTransactionColumn["DATE"] = "date";
    PaymentTransactionColumn["TIME"] = "time";
    PaymentTransactionColumn["TRANSACTION_TYPE"] = "type";
    PaymentTransactionColumn["PROVIDER"] = "provider";
    PaymentTransactionColumn["STATUS"] = "status";
    PaymentTransactionColumn["STATUS_ICON"] = "status-icon";
    PaymentTransactionColumn["AMOUNT"] = "amount";
    PaymentTransactionColumn["BALANCE"] = "balance";
    PaymentTransactionColumn["INFO"] = "info";
})(exports.PaymentTransactionColumn || (exports.PaymentTransactionColumn = {}));
(function (BonusesTransactionColumn) {
    BonusesTransactionColumn["BONUS_NAME"] = "bonus-name";
    BonusesTransactionColumn["TIME"] = "time";
    BonusesTransactionColumn["AMOUNT"] = "amount";
})(exports.BonusesTransactionColumn || (exports.BonusesTransactionColumn = {}));
(function (WalletEnvironment) {
    WalletEnvironment["PRODUCTION"] = "prod";
    WalletEnvironment["DEVELOPMENT"] = "development";
})(exports.WalletEnvironment || (exports.WalletEnvironment = {}));
(function (WalletValidationStrategy) {
    WalletValidationStrategy["DEFAULT"] = "";
    WalletValidationStrategy["THRILLS"] = "thrills";
})(exports.WalletValidationStrategy || (exports.WalletValidationStrategy = {}));
(function (WalletView) {
    WalletView["DEPOSIT"] = "deposit";
    WalletView["WITHDRAWAL"] = "withdrawal";
    WalletView["HISTORY"] = "history";
    WalletView["BONUS"] = "bonus";
})(exports.WalletView || (exports.WalletView = {}));
(function (WalletTheme) {
    WalletTheme["DARK"] = "dark";
    WalletTheme["LIGHT"] = "light";
})(exports.WalletTheme || (exports.WalletTheme = {}));
(function (WalletViewRouteName) {
    WalletViewRouteName["BONUSES"] = "bonuses";
    WalletViewRouteName["DEPOSIT"] = "deposit";
    WalletViewRouteName["HISTORY"] = "history";
    WalletViewRouteName["WITHDRAW"] = "withdraw";
})(exports.WalletViewRouteName || (exports.WalletViewRouteName = {}));
(function (WalletHistoryViewRouteName) {
    WalletHistoryViewRouteName["GAMING"] = "gaming";
    WalletHistoryViewRouteName["PAYMENTS"] = "payments";
    WalletHistoryViewRouteName["SEARCH"] = "search";
})(exports.WalletHistoryViewRouteName || (exports.WalletHistoryViewRouteName = {}));
(function (HistoryType) {
    HistoryType["GAMING"] = "gaming";
    HistoryType["PAYMENTS"] = "payments";
    HistoryType["BONUSES"] = "bonuses";
})(exports.HistoryType || (exports.HistoryType = {}));
